import type { SVGProps } from 'react';

const SvgIconChevron = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" stroke="currentColor" width={16} height={16} viewBox="0 0 16 16" {...props}>
    <path d="M13 6 8 11 3 6" strokeWidth="1.5" strokeLinejoin="round" />
  </svg>
);
export default SvgIconChevron;
